import type { CurrentPlan, SubscriptionView } from "@/lib/api/organizations";
import { formatMoneyCents } from "@/lib/format";

/// One seat for one billing period, in the currency it is billed in.
export interface SeatRate {
  amount: number;
  currency: string;
  taxOnTop: boolean;
}

/// What the subscription bills, from Paddle's own record of it; `null` where
/// that record names no amount, never the catalog's list price.
export function seatRate(
  plan: CurrentPlan | null,
  subscription: SubscriptionView | null | undefined,
): SeatRate | null {
  const currency = subscription?.currency_code;
  const amount = subscription?.unit_price_minor;
  if (!plan || plan.price_cents <= 0 || !currency || amount == null) {
    return null;
  }
  return { amount, currency, taxOnTop: subscription?.tax_on_top === true };
}

export function formatSeatMoney(rate: SeatRate, seats = 1): string {
  return formatMoneyCents(rate.amount * seats, rate.currency);
}

/// The website's wording, so a buyer reads the same thing before and after.
export const PLUS_TAX = "plus tax";

/// A charge Paddle priced carries its tax, which a rate without it must say.
export const INCL_TAX = "incl. tax";
